export default __webpack_public_path__ + "static/media/BankLogos_web_833 x 199 – 1.dd0e1695.png";